var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 62,
    viewBox: "0 0 36 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1807 60.9307C32.8383 62.2731 30.6617 62.2731 29.3193 60.9307L1.81932 33.4307C0.476894 32.0883 0.476894 29.9117 1.81932 28.5693L29.3193 1.06932C30.6617 -0.273109 32.8383 -0.273109 34.1807 1.06932C35.5231 2.41174 35.5231 4.58825 34.1807 5.93068L9.11136 31L34.1807 56.0693C35.5231 57.4117 35.5231 59.5883 34.1807 60.9307Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeftArrow);
export default __webpack_public_path__ + "static/media/CarouselLeftArrow.ae9b5284c9837368aba45dc0bb2d79d1.svg";
export { ForwardRef as ReactComponent };